import { render, staticRenderFns } from "./CmpPrice.vue?vue&type=template&id=35d40a64&scoped=true&"
import script from "./CmpPrice.vue?vue&type=script&lang=js&"
export * from "./CmpPrice.vue?vue&type=script&lang=js&"
import style0 from "./CmpPrice.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CmpPrice.vue?vue&type=style&index=1&id=35d40a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d40a64",
  null
  
)

export default component.exports